export default {
  couldntFindUserInfo: 'Couldn´t find person´s information',
  dontHaveLikesInfo: 'No instagram likes or music preferences yet',
  profile: 'Profile',
  toBeDefined: 'To be defined',
  extradataTitle: 'Custom field title',
  openUserDetails: 'Open person´s details',
  asignName: 'Add a Firstname',
  asignLastName: 'Add a Lastname'
}
